import React, { useEffect, useState } from 'react';
import { default as ReactOtpInput } from 'react-otp-input';
import { InputErrorIcon } from 'src/assets/images';
import './otp-input.scss';

type ErrorStateType = {
  otp?: string;
};

export default function OtpInput({ field, form, ...props }) {
  const { ...newProps } = props;
  const [errorState, setErrorState] = useState<ErrorStateType>(form.errors);
  const showError = !!errorState.otp;

  useEffect(() => {
    setErrorState(form.errors);
  }, [form.errors]);

  return (
    <div className="otp-input-wrapper">
      <ReactOtpInput
        {...newProps}
        isInputNum={true}
        containerStyle="otp-input-container has-margin-top-7"
        inputStyle={`otp-input ${showError ? 'error-style' : ''}`}
        value={field.value}
        onChange={(value) => {
          form.setFieldValue(field.name, value);
          form.setFieldTouched(field.name, true);

          if (value === '') {
            setErrorState({
              otp: 'OTP is required',
            });
          } else {
            setErrorState(form.errors);
          }
        }}
      />
      <div className="field-error">
        {showError && (
          <>
            <img className="error-image" src={InputErrorIcon} />
            &nbsp;
            <span>{errorState[field.name]}</span>
          </>
        )}
      </div>
    </div>
  );
}
